// removed by extract-text-webpack-plugin
module.exports = {"container":"ZlZyu17avqaxVlYJQlAu_","icon":"_196MWbPulNJEzpxqzQpk8f","title":"_2XhdbuwAORQ6E6KB-gNeIu","contactlist":"TyW2GGuOxqpIL2EOh7j1e"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Create/styles.css
// module id = 3035
// module chunks = 0